import { type AppBuild } from "@vidario/domain";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { useVidarioClient } from "../client";
import { queryKeys } from "../queryKeys";

/** The running release/commit from `/health/`. It only changes on a deploy,
 * so once per session is enough. */
export function useAppBuild(): UseQueryResult<AppBuild> {
  const client = useVidarioClient();
  return useQuery({
    queryKey: queryKeys.health(),
    queryFn: () => client.getHealth(),
    staleTime: Infinity,
    retry: false,
  });
}
